var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9939 5.43533C20.3056 5.7081 20.3372 6.18192 20.0644 6.49364L9.56443 18.4936C9.42774 18.6499 9.23242 18.7424 9.02496 18.7494C8.8175 18.7563 8.61645 18.6769 8.46967 18.5301L3.96967 14.0301C3.67678 13.7372 3.67678 13.2623 3.96967 12.9694C4.26256 12.6765 4.73744 12.6765 5.03033 12.9694L8.96347 16.9026L18.9356 5.50589C19.2083 5.19416 19.6822 5.16257 19.9939 5.43533Z",
    fill: "#82F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.5cfdc3cc13de60f9bcac93bd0389f456.svg";
export { ForwardRef as ReactComponent };